var _excluded = ["labelProps", "aria-label", "colSpan", "error", "helperTextProps", "maxChars", "isDisabled", "isReadOnly", "isViewMode", "isRequired", "showOptionalIndicator", "isHidden", "size", "name", "id", "control", "viewModePlaceholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line no-restricted-imports
import { forwardRef } from 'react';
import { useController } from 'react-hook-form';
import { mergeRefs } from '../../../../../utils';
import { _FormField as FormField, useFormContext } from '../../../../internal';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private Please use `Form.<component-name>` from `@melio/penny`. do not use this function directly
 */
export function createFormFieldInput(Comp) {
  var TargetComponent = /*#__PURE__*/forwardRef((_ref, ref) => {
    var _formContext$size;

    var {
      labelProps,
      'aria-label': ariaLabel,
      colSpan,
      error,
      helperTextProps,
      maxChars,
      isDisabled,
      isReadOnly,
      isViewMode,
      isRequired,
      showOptionalIndicator,
      isHidden,
      size,
      name,
      id,
      control,
      viewModePlaceholder
    } = _ref,
        inputProps = _objectWithoutProperties(_ref, _excluded);

    // The ariaLabel and labelProps props are mutually exclusive, meaning that either labelProps or ariaLabel exists, never both simultaneously.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    var formFieldProps = {
      labelProps,
      'aria-label': ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : labelProps === null || labelProps === void 0 ? void 0 : labelProps.label,
      colSpan,
      error,
      helperTextProps,
      maxChars,
      isReadOnly,
      isViewMode,
      isRequired,
      showOptionalIndicator,
      isHidden,
      name,
      id
    };
    var {
      field
    } = useController({
      name,
      control
    });
    var formContext = useFormContext();
    var isFieldDisabled = formContext.isDisabled || isDisabled;
    var isFieldReadOnly = formContext.isReadOnly || isReadOnly || formContext.isLoading;
    var isFieldInViewMode = formContext.isViewMode || isViewMode;
    var fieldSize = (_formContext$size = formContext.size) !== null && _formContext$size !== void 0 ? _formContext$size : size;
    return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({}, formFieldProps), {}, {
      size: fieldSize,
      isDisabled: isFieldDisabled,
      isReadOnly: isFieldReadOnly,
      isViewMode: isFieldInViewMode,
      columns: formContext.columns,
      value: field.value,
      children: /*#__PURE__*/_jsx(Comp, _objectSpread(_objectSpread(_objectSpread({}, field), {}, {
        "data-testid": name && "form-input-".concat(name)
      }, inputProps), {}, {
        id: id,
        placeholder: isFieldInViewMode ? viewModePlaceholder : inputProps.placeholder,
        isDisabled: isFieldDisabled,
        isReadOnly: isFieldReadOnly,
        isViewMode: isFieldInViewMode,
        size: fieldSize,
        ref: mergeRefs([field.ref, ref])
      }))
    }));
  });

  if (Comp.displayName) {
    TargetComponent.displayName = "Form.".concat(Comp.displayName.slice(1));
  }

  return TargetComponent;
}
//# sourceMappingURL=utils.js.map